import { type FC } from 'react'
import { Layout } from '@egw/layouts'
import { Headers } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { SettingsPage as Settings } from '@egw/features-settings'

export const SettingsPage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.settings.title')} />
      <Settings />
    </Layout>
  )
}
